import { ExcavationSignatures, ExcavationWorkflowActivity } from "../RoadClosureWorkPermit/ExcavationPermitActivity";
import ExcavationPermitDetails from "../RoadClosureWorkPermit/ExcavationPermitDetails";
import { fetchExcavationViewData, isExcavationSummary } from "../RoadClosureWorkPermit/excavationViewData";
// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";
// import {
//   Box,
//   Card,
//   CardContent,
//   Divider,
//   Typography,
//   Chip,
//   Stack,
//   CircularProgress,
// } from "@mui/material";
// import API_URL from "../../src/Config";
// import "./Form.css";
// import "./permitViewPage.css";
// import { IoArrowBackCircle } from "react-icons/io5";

// function IssuerViewDetails({ isSidebarExpanded }) {
//   const navigate = useNavigate();
//   const { permit_id } = useParams();

//   const [isLoading, setIsLoading] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [severity, setSeverity] = useState("success");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [reason, setReason] = useState("");
//   const [permit, setPermit] = useState(null);
//   const [isApprovePopupOpen, setIsApprovePopupOpen] = useState(false);
//   const [showRejectPopup, setShowRejectPopup] = useState(false);
//   const [isPopupOpen, setIsPopupOpen] = useState(false);

//   const handleReasonChange = (e) => setReason(e.target.value);

//   const handleRejectClick = () => setIsPopupOpen(true);

//   const handleApproveConfirm = () => setIsApprovePopupOpen(true);

//   const handleRejectConfirm = () => {
//     handleRejectClick();
//     setShowRejectPopup(false);
//   };

//   const closeApprovePopup = () => setIsApprovePopupOpen(false);

//   const confirmApprove = () => {
//     handleSaveClick();
//     setIsApprovePopupOpen(false);
//   };

//   const closePopup = () => setIsPopupOpen(false);

//   // -------- APPROVE ----------
//   const handleSaveClick = async () => {
//     try {
//       const authKey = localStorage.getItem("authKey");

//       const response = await axios.put(
//         `${API_URL}/api/v2/issuer/final_issue`,
//         { permit_id },
//         { headers: { Authorization: authKey } }
//       );

//       if (response.status === 200) {
//         showSnackbar("Work permit approved successfully!");
//         setTimeout(() => navigate("/oandm-head-inspection"), 1000);
//       }
//     } catch (error) {
//       console.error("Error approving permit:", error);

//       // Extract backend message safely
//       const backendMessage =
//         error?.response?.data?.message ||
//         error?.message ||
//         "Something went wrong.";

//       // Show the backend message in snackbar
//       showSnackbar(backendMessage, "error");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // -------- REJECT ----------
//   const handleSaveRejectClick = async () => {
//     const payload = {
//       permit_id: permit_id, // Maps to `permit_id` in backend
//       request_type: "new", // Set `request_type` as "new"
//       reason: reason, // From the form input
//     };

//     try {
//       setIsLoading(true);
//       const authKey = localStorage.getItem("authKey");

//       const response = await axios.post(
//         `${API_URL}/api/reject_permit`,
//         payload,
//         {
//           headers: { Authorization: authKey },
//         }
//       );

//       if (response.status === 200) {
//         showSnackbar("Permit rejected successfully.");
//         setTimeout(() => navigate(`/cold-work-permit`), 1000);
//       }
//     } catch (error) {
//       showSnackbar("Error rejecting permit", "error");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // ------- FETCH PERMIT DETAILS --------
//   const fetchPermitDetails = async () => {
//     try {
//       const authKey = localStorage.getItem("authKey");

//       const res = await axios.get(
//         `${API_URL}/api/get_permit_details?permit_id=${permit_id}`,
//         { headers: { Authorization: authKey } }
//       );

//       setPermit(res.data);
//     } catch (err) {
//       showSnackbar("Failed to load permit details", "error");
//     }
//   };

//   useEffect(() => {
//     if (permit_id) fetchPermitDetails();
//   }, [permit_id]);

//   const showSnackbar = (message, type = "success") => {
//     setSnackbarMessage(message);
//     setSeverity(type);
//     setSnackbarOpen(true);
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleCancelClick = () => navigate("/cold-work-permit");

//   if (!permit)
//     return (
//       <div className="loader-center">
//         <CircularProgress />
//       </div>
//     );

//   const common = permit.commonFields || {};
//   const work = permit.workDetails?.[0] || {};
//   const hazards = permit.hazardsPrecautions || [];
//   const checklist = permit.checklistItems || [];

//   // ----------------------------------------------------------------
//   // SAFELY PARSE HAZARD JSON STRINGS
//   // ----------------------------------------------------------------
//   const parseSafe = (value) => {
//     try {
//       if (!value) return [];
//       if (typeof value === "string") return JSON.parse(value);
//       return value;
//     } catch {
//       return [];
//     }
//   };

//   // ----------------------------------------------------------------
//   // RENDER SECTION 1 → WORK DETAILS
//   // ----------------------------------------------------------------
//   const renderWorkDetails = () => (
//     <Card sx={{ mb: 3, borderRadius: 3, boxShadow: 4 }}>
//       <CardContent>
//         <Typography
//           variant="h6"
//           sx={{
//             mb: 2,
//             color: "primary.main",
//             fontWeight: "bold",
//             borderBottom: "2px solid",
//             borderColor: "primary.light",
//             pb: 1,
//           }}
//         >
//           Work Permit Details
//         </Typography>

//         <Box
//           sx={{
//             display: "grid",
//             gridTemplateColumns: { xs: "1fr", md: "1fr 1px 1fr" },
//             gap: 2,
//           }}
//         >
//           {/* LEFT */}
//           <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//             <DetailItem label="Permit Type" value={common.work_permit_name} />
//             <DetailItem label="Issued To" value={work.issued_to} />
//             <DetailItem label="Department" value={work.department_name} />
//             <DetailItem label="Receiver Name" value={work.receiver_name} />
//             <DetailItem label="Area" value={work.area} />
//             <DetailItem label="Unit" value={work.unit} />
//           </Box>

//           {/* DIVIDER */}
//           <Box
//             sx={{
//               width: "1px",
//               backgroundColor: "grey.300",
//               display: { xs: "none", md: "block" },
//             }}
//           />

//           {/* RIGHT */}
//           <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//             <DetailItem label="Section" value={work.section} />
//             <DetailItem label="Contractor" value={work.contractor} />
//             <DetailItem
//               label="Work Description"
//               value={work.work_description}
//             />
//             <DetailItem label="Start Date & Time" value={work.valid_from} />
//             <DetailItem label="End Date & Time" value={work.valid_to} />
//           </Box>
//         </Box>
//       </CardContent>
//     </Card>
//   );

//   // ----------------------------------------------------------------
//   // RENDER SECTION 2 → HAZARDS & PRECAUTIONS
//   // ----------------------------------------------------------------
//   const renderHazards = () => {
//     const hazardData = hazards[0] || {};

//     const residual = parseSafe(hazardData.residual_hazards);
//     const ppe = parseSafe(hazardData.ppe_precautions);

//     return (
//       <Card sx={{ mb: 3, borderRadius: 3, boxShadow: 3 }}>
//         <CardContent>
//           <Typography
//             variant="h6"
//             sx={{
//               mb: 3,
//               color: "primary.main",
//               fontWeight: "bold",
//               borderBottom: "2px solid",
//               borderColor: "primary.light",
//               pb: 1,
//             }}
//           >
//             Hazards & Precautions
//           </Typography>

//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: { xs: "1fr", md: "1fr 1px 1fr" },
//               gap: 2,
//             }}
//           >
//             {/* RESIDUAL */}
//             <Box>
//               <Typography variant="subtitle2">Residual Hazards:</Typography>
//               <Stack direction="row" flexWrap="wrap" spacing={1} mt={1}>
//                 {residual.length ? (
//                   residual.map((item, i) => (
//                     <Chip
//                       key={i}
//                       label={item}
//                       variant="outlined"
//                       color="primary"
//                     />
//                   ))
//                 ) : (
//                   <Typography>No residual hazards</Typography>
//                 )}
//               </Stack>
//             </Box>

//             {/* DIVIDER */}
//             <Box
//               sx={{
//                 width: "1px",
//                 background: "grey.300",
//                 display: { xs: "none", md: "block" },
//               }}
//             />

//             {/* PPE */}
//             <Box>
//               <Typography variant="subtitle2">PPE Precautions:</Typography>
//               <Stack direction="row" flexWrap="wrap" spacing={1} mt={1}>
//                 {ppe.length ? (
//                   ppe.map((item, i) => (
//                     <Chip
//                       key={i}
//                       label={item}
//                       variant="outlined"
//                       color="primary"
//                     />
//                   ))
//                 ) : (
//                   <Typography>No PPE precautions</Typography>
//                 )}
//               </Stack>
//             </Box>
//           </Box>

//           <Box sx={{ mt: 2 }}>
//             <Typography variant="subtitle2">
//               Additional Precaution Description:
//             </Typography>
//             <Typography
//               sx={{
//                 mt: 1,
//                 p: 2,
//                 background: "#f5f5f5",
//                 borderRadius: 2,
//               }}
//             >
//               {hazardData.precaution_description || "No description"}
//             </Typography>
//           </Box>
//         </CardContent>
//       </Card>
//     );
//   };

//   const dynamicFieldKeys = [
//     "h2s_gas",
//     "o2_gas",
//     "hc_gas",
//     "lel_gas",
//     "toxic_gases",
//     "vehicle_regd_no",
//     "electrical_permit_no",
//     "equipment_status",
//     "permit_no",
//   ];

//   const extractInputFields = (item) => {
//     return dynamicFieldKeys
//       .filter(
//         (key) =>
//           item[key] !== null && item[key] !== "" && item[key] !== undefined
//       )
//       .map((key) => ({
//         field_name: key.replace(/_/g, " ").toUpperCase(),
//         field_value: item[key],
//       }));
//   };
//   // ----------------------------------------------------------------
//   // RENDER SECTION 3 → CHECKLIST
//   // ----------------------------------------------------------------
//   const renderChecklist = () => (
//     <Card sx={{ mb: 3, borderRadius: 3, boxShadow: 3 }}>
//       <CardContent>
//         <Typography variant="h6" sx={{ mb: 2, color: "#1976d2" }}>
//           Checklist Items
//         </Typography>

//         <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
//           {checklist.map((item, i) => {
//             const inputFields = extractInputFields(item); // NEW

//             return (
//               <li
//                 key={i}
//                 style={{
//                   padding: "10px",
//                   border: "1px solid #ddd",
//                   borderRadius: "8px",
//                   marginBottom: "10px",
//                   background: "#fafafa",
//                 }}
//               >
//                 <Typography>{item.description}</Typography>

//                 <Typography sx={{ color: "gray", fontSize: "13px" }}>
//                   Status:{" "}
//                   <span
//                     style={{ color: item.work_status === 1 ? "green" : "red" }}
//                   >
//                     {item.work_status === 1 ? "Done" : "Not Required"}
//                   </span>
//                 </Typography>

//                 {inputFields.length > 0 && (
//                   <Stack direction="row" flexWrap="wrap" spacing={1} mt={1}>
//                     {inputFields?.map((inp, j) => (
//                       <Chip
//                         key={j}
//                         label={`${inp?.field_name}: ${inp?.field_value}`}
//                         variant="outlined"
//                         color="primary"
//                       />
//                     ))}
//                   </Stack>
//                 )}
//               </li>
//             );
//           })}
//         </ul>
//       </CardContent>
//     </Card>
//   );

//   // ----------------------------------------------------------------
//   // DETAIL ITEM COMPONENT
//   // ----------------------------------------------------------------
//   const DetailItem = ({ label, value }) => (
//     <Box>
//       <Typography variant="subtitle2" color="textSecondary">
//         {label}:
//       </Typography>
//       <Typography variant="body1" sx={{ fontWeight: 500 }}>
//         {value || "—"}
//       </Typography>
//     </Box>
//   );

//   return (
//     <div
//       className={`data-list-content-container page-content ${
//         isSidebarExpanded ? "expanded" : "collapsed"
//       }`}
//     >
//       <div className="data-form-content">
//         {/* HEADER */}
//         <div className="data-form-header">
//           <div className="data-form-header-content">
//             <div className="data-form-heading-content-left-side">
//               <IoArrowBackCircle
//                 style={{ color: "#233b80", cursor: "pointer" }}
//                 size={25}
//                 onClick={handleCancelClick}
//               />
//               <span className="data-form-heading-text">Work Permit View</span>
//             </div>
//           </div>
//         </div>

//         <Divider />

//         {/* PAGE CONTENT */}
//         <div className="data-form-body-permit-fands">
//           <Box
//             sx={{
//               width: "100%",
//               mt: 2,
//               display: "flex",
//               flexDirection: "column",
//               gap: 3,
//             }}
//           >
//             {/* Work + Hazards */}
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", md: "row" },
//                 gap: 3,
//               }}
//             >
//               <Box sx={{ flex: 1 }}>{renderWorkDetails()}</Box>
//               <Box sx={{ flex: 1 }}>{renderHazards()}</Box>
//             </Box>

//             {/* Checklist */}
//             {renderChecklist()}
//           </Box>
//         </div>

//         {/* FOOTER BUTTONS */}
//         <div className="footer">
//           <div className="button-group">
//             <button
//               className="data-form-cancel-button"
//               onClick={handleCancelClick}
//             >
//               Cancel
//             </button>

//             {(common?.request_status === "O&M Verified" || common?.request_status === "Fire&Safety Verified") ? (
//               <>
//                 <button
//                   style={{ marginLeft: "10px" }}
//                   className="data-form-save-button approverd-button-permit approve_btn_clr"
//                   type="button"
//                   onClick={handleApproveConfirm}
//                 >
//                   Approve
//                 </button>

//                 <button
//                   className="data-form-reject-button"
//                   type="button"
//                   onClick={() => setShowRejectPopup(true)}
//                 >
//                   Reject
//                 </button>
//               </>
//             ) : null}
//           </div>
//         </div>

//         {/* SNACKBAR */}
//         <Snackbar
//           open={snackbarOpen}
//           autoHideDuration={4000}
//           onClose={handleSnackbarClose}
//           anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         >
//           <MuiAlert
//             severity={severity}
//             variant="filled"
//             onClose={handleSnackbarClose}
//           >
//             {snackbarMessage}
//           </MuiAlert>
//         </Snackbar>
//       </div>

//       {/* APPROVE CONFIRM POPUP */}
//       {isApprovePopupOpen && (
//         <div className="permit-approval-popup">
//           <div className="permit-approval-popup-content">
//             <div className="approval-popup-header">Confirm Approval</div>
//             <p className="approval-popup-message">
//               Are you sure you want to approve this permit?
//             </p>
//             <div className="approval-popup-buttons">
//               <button className="approve-button approve_btn_clr" onClick={confirmApprove}>
//                 Yes, Approve
//               </button>
//               <button className="cancel-button" onClick={closeApprovePopup}>
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* REJECT CONFIRM POPUP */}
//       {showRejectPopup && (
//         <div className="confirm-delete-popup">
//           <div className="confirm-delete-popup-content">
//             <div className="confirm-model">
//               <div className="confirm-model-content">
//                 <div className="confirm-model-content-body">
//                   <p>Are you sure you want to reject this request?</p>
//                 </div>
//                 <div className="confirm-model-content-footer">
//                   <button
//                     className="reject-confirm-button"
//                     onClick={handleRejectConfirm}
//                   >
//                     Yes, Reject
//                   </button>
//                   <button
//                     className="reject-cancel-button"
//                     onClick={() => setShowRejectPopup(false)}
//                   >
//                     Cancel
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* REJECT REASON POPUP */}
//       {isPopupOpen && (
//         <div className="permit-popup-model">
//           <div className="permit-popup-content">
//             <div className="reminder-popup-model-header">
//               <div className="reminder-popup-model-content-header-left-part">
//                 Reject Request Permit
//               </div>

//               <div className="popup-new-form">
//                 <form className="permit-popup-form-detail">
//                   <div className="new-data-form">
//                     <div className="form-group email-filed">
//                       <label htmlFor="reason">
//                         Reason <span className="text-danger">*</span>
//                       </label>

//                       <div className="input-group">
//                         <textarea
//                           id="reason"
//                           name="reason"
//                           placeholder="Enter reason for rejection"
//                           value={reason}
//                           onChange={handleReasonChange}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </form>
//               </div>

//               <div className="footers">
//                 <div className="button-group-email">
//                   <button
//                     className="person-user-save-button"
//                     onClick={handleSaveRejectClick}
//                     disabled={isLoading}
//                   >
//                     {isLoading ? "Rejecting" : "Reject"}
//                   </button>

//                   <button
//                     className="person-user-cancel-button"
//                     onClick={closePopup}
//                   >
//                     Cancel
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default IssuerViewDetails;




import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Typography,
  Chip,
  Stack,
  CircularProgress,
} from "@mui/material";
import API_URL from "../../src/Config";
import "./Form.css";
import "./permitViewPage.css";
import { IoArrowBackCircle } from "react-icons/io5";

// ─── Permit type check ────────────────────────────────────────────────────────
const EXCAVATION_PERMIT_NAME = "Excavation Clearance/Road Closure";

function IssuerViewDetails({ isSidebarExpanded }) {
  const navigate = useNavigate();
  const { permit_id } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [permit, setPermit] = useState(null);
  const [isApprovePopupOpen, setIsApprovePopupOpen] = useState(false);
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleReasonChange = (e) => setReason(e.target.value);

  const handleRejectClick = () => setIsPopupOpen(true);

  const handleApproveConfirm = () => setIsApprovePopupOpen(true);

  const handleRejectConfirm = () => {
    handleRejectClick();
    setShowRejectPopup(false);
  };

  const closeApprovePopup = () => setIsApprovePopupOpen(false);

  const confirmApprove = () => {
    handleSaveClick();
    setIsApprovePopupOpen(false);
  };

  const closePopup = () => setIsPopupOpen(false);

  // -------- APPROVE ----------
  const handleSaveClick = async () => {
    try {
      const authKey = localStorage.getItem("authKey");

      const response = await axios.put(
        `${API_URL}/api/v2/issuer/final_issue`,
        { permit_id },
        { headers: { Authorization: authKey } }
      );

      if (response.status === 200) {
        showSnackbar("Work permit approved successfully!");
        setTimeout(() => navigate("/oandm-head-inspection"), 1000);
      }
    } catch (error) {
      console.error("Error approving permit:", error);

      const backendMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong.";

      showSnackbar(backendMessage, "error");
    } finally {
      setIsLoading(false);
    }
  };

  // -------- REJECT ----------
  const handleSaveRejectClick = async () => {
    const payload = {
      permit_id: permit_id,
      request_type: "new",
      reason: reason,
    };

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.post(
        `${API_URL}/api/reject_permit`,
        payload,
        {
          headers: { Authorization: authKey },
        }
      );

      if (response.status === 200) {
        showSnackbar("Permit rejected successfully.");
        setTimeout(() => navigate(`/cold-work-permit`), 1000);
      }
    } catch (error) {
      showSnackbar("Error rejecting permit", "error");
    } finally {
      setIsLoading(false);
    }
  };

  // ------- FETCH PERMIT DETAILS --------
  const fetchPermitDetails = async () => {
    try {
      const authKey = localStorage.getItem("authKey");

      const res = await axios.get(
        `${API_URL}/api/get_permit_details?permit_id=${permit_id}`,
        { headers: { Authorization: authKey } }
      );

      setPermit(isExcavationSummary(res.data)
        ? await fetchExcavationViewData(permit_id, { Authorization: authKey }, res.data)
        : res.data);
    } catch (err) {
      showSnackbar("Failed to load permit details", "error");
    }
  };

  useEffect(() => {
    if (permit_id) fetchPermitDetails();
  }, [permit_id]);

  const showSnackbar = (message, type = "success") => {
    setSnackbarMessage(message);
    setSeverity(type);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleCancelClick = () => navigate("/cold-work-permit");

  if (!permit)
    return (
      <div className="loader-center">
        <CircularProgress />
      </div>
    );

  const common = permit.commonFields || {};
  const work = permit.workDetails?.[0] || {};
  const hazards = permit.hazardsPrecautions || [];
  const checklist = permit.checklistItems || [];
  const departmentApprovals = permit.departmentApprovals || [];
  const signatures = permit.signatures || [];
  const workflowLogs = permit.workflowLogs || [];

  // ─── Is excavation permit? ────────────────────────────────────────────────
  const isExcavationPermit =
    Boolean(permit.excavationView) || common.work_permit_name === EXCAVATION_PERMIT_NAME ||
    work.work_permit_name === EXCAVATION_PERMIT_NAME;

  // ----------------------------------------------------------------
  // SAFELY PARSE HAZARD JSON STRINGS
  // ----------------------------------------------------------------
  const parseSafe = (value) => {
    try {
      if (!value) return [];
      if (typeof value === "string") return JSON.parse(value);
      return value;
    } catch {
      return [];
    }
  };

  // ----------------------------------------------------------------
  // DETAIL ITEM COMPONENT
  // ----------------------------------------------------------------
  const DetailItem = ({ label, value }) => (
    <Box>
      <Typography variant="subtitle2" color="textSecondary">
        {label}:
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: 500 }}>
        {value || "—"}
      </Typography>
    </Box>
  );

  // ----------------------------------------------------------------
  // RENDER SECTION 1 → WORK DETAILS
  // ----------------------------------------------------------------
  const renderWorkDetails = () => (
    <Card sx={{ mb: 3, borderRadius: 3, boxShadow: 4 }}>
      <CardContent>
        <Typography
          variant="h6"
          sx={{
            mb: 2,
            color: "primary.main",
            fontWeight: "bold",
            borderBottom: "2px solid",
            borderColor: "primary.light",
            pb: 1,
          }}
        >
          Work Permit Details
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1px 1fr" },
            gap: 2,
          }}
        >
          {/* LEFT */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <DetailItem label="Permit Type" value={common.work_permit_name} />
            <DetailItem label="Issued To" value={work.issued_to} />
            <DetailItem label="Department" value={work.department_name} />
            <DetailItem label="Receiver Name" value={work.receiver_name} />
            <DetailItem label="Area" value={work.area} />
            <DetailItem label="Unit" value={work.unit} />
          </Box>

          {/* DIVIDER */}
          <Box
            sx={{
              width: "1px",
              backgroundColor: "grey.300",
              display: { xs: "none", md: "block" },
            }}
          />

          {/* RIGHT */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <DetailItem label="Section" value={work.section} />
            <DetailItem label="Contractor" value={work.contractor} />
            <DetailItem
              label="Work Description"
              value={work.work_description}
            />
            <DetailItem label="Start Date & Time" value={work.valid_from} />
            <DetailItem label="End Date & Time" value={work.valid_to} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );

  // ----------------------------------------------------------------
  // RENDER SECTION 2 → HAZARDS & PRECAUTIONS
  // ----------------------------------------------------------------
  const renderHazards = () => {
    const hazardData = hazards[0] || {};

    const residual = parseSafe(hazardData.residual_hazards);
    const ppe = parseSafe(hazardData.ppe_precautions);

    return (
      <Card sx={{ mb: 3, borderRadius: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography
            variant="h6"
            sx={{
              mb: 3,
              color: "primary.main",
              fontWeight: "bold",
              borderBottom: "2px solid",
              borderColor: "primary.light",
              pb: 1,
            }}
          >
            Hazards & Precautions
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1px 1fr" },
              gap: 2,
            }}
          >
            {/* RESIDUAL */}
            <Box>
              <Typography variant="subtitle2">Residual Hazards:</Typography>
              <Stack direction="row" flexWrap="wrap" spacing={1} mt={1}>
                {residual.length ? (
                  residual.map((item, i) => (
                    <Chip
                      key={i}
                      label={item}
                      variant="outlined"
                      color="primary"
                    />
                  ))
                ) : (
                  <Typography>No residual hazards</Typography>
                )}
              </Stack>
            </Box>

            {/* DIVIDER */}
            <Box
              sx={{
                width: "1px",
                background: "grey.300",
                display: { xs: "none", md: "block" },
              }}
            />

            {/* PPE */}
            <Box>
              <Typography variant="subtitle2">PPE Precautions:</Typography>
              <Stack direction="row" flexWrap="wrap" spacing={1} mt={1}>
                {ppe.length ? (
                  ppe.map((item, i) => (
                    <Chip
                      key={i}
                      label={item}
                      variant="outlined"
                      color="primary"
                    />
                  ))
                ) : (
                  <Typography>No PPE precautions</Typography>
                )}
              </Stack>
            </Box>
          </Box>

          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2">
              Additional Precaution Description:
            </Typography>
            <Typography
              sx={{
                mt: 1,
                p: 2,
                background: "#f5f5f5",
                borderRadius: 2,
              }}
            >
              {hazardData.precaution_description || "No description"}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    );
  };

  const dynamicFieldKeys = [
    "h2s_gas",
    "o2_gas",
    "hc_gas",
    "lel_gas",
    "toxic_gases",
    "vehicle_regd_no",
    "electrical_permit_no",
    "equipment_status",
    "permit_no",
  ];

  const extractInputFields = (item) => {
    return dynamicFieldKeys
      .filter(
        (key) =>
          item[key] !== null && item[key] !== "" && item[key] !== undefined
      )
      .map((key) => ({
        field_name: key.replace(/_/g, " ").toUpperCase(),
        field_value: item[key],
      }));
  };

  // ----------------------------------------------------------------
  // RENDER SECTION 3 → CHECKLIST
  // ----------------------------------------------------------------
  const renderChecklist = () => (
    <Card sx={{ mb: 3, borderRadius: 3, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2, color: "#1976d2" }}>
          Checklist Items
        </Typography>

        <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
          {checklist.map((item, i) => {
            const inputFields = extractInputFields(item);

            return (
              <li
                key={i}
                style={{
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  marginBottom: "10px",
                  background: "#fafafa",
                }}
              >
                <Typography>{item.description}</Typography>

                <Typography sx={{ color: "gray", fontSize: "13px" }}>
                  Status:{" "}
                  <span
                    style={{ color: item.work_status === 1 ? "green" : "red" }}
                  >
                    {item.work_status === 1 ? "Done" : "Not Required"}
                  </span>
                </Typography>

                {inputFields.length > 0 && (
                  <Stack direction="row" flexWrap="wrap" spacing={1} mt={1}>
                    {inputFields?.map((inp, j) => (
                      <Chip
                        key={j}
                        label={`${inp?.field_name}: ${inp?.field_value}`}
                        variant="outlined"
                        color="primary"
                      />
                    ))}
                  </Stack>
                )}
              </li>
            );
          })}
        </ul>
      </CardContent>
    </Card>
  );

  // ================================================================
  // EXCAVATION-SPECIFIC SECTIONS
  // ================================================================

  // ----------------------------------------------------------------
  // EXC-1 → EXCAVATION WORK DETAILS (extra fields)
  // ----------------------------------------------------------------
  const renderSignatures = () => <ExcavationSignatures signatures={signatures} />;
  const renderWorkflowLogs = () => <ExcavationWorkflowActivity logs={workflowLogs} />;

  return (
    <div
      className={`data-list-content-container page-content ${
        (isSidebarExpanded ? "expanded" : "collapsed") + (isExcavationPermit ? " excavation-details-page" : "")
      }`}
    >
      <div className="data-form-content">
        {/* HEADER */}
        <div className="data-form-header">
          <div className="data-form-header-content">
            <div className="data-form-heading-content-left-side">
              <IoArrowBackCircle
                style={{ color: "#233b80", cursor: "pointer" }}
                size={25}
                onClick={handleCancelClick}
              />
              <span className="data-form-heading-text">{isExcavationPermit ? "Excavation Permit - View Details" : "Work Permit View"}</span>
            </div>
          </div>
        </div>

        <Divider />

        {/* PAGE CONTENT */}
        <div className="data-form-body-permit-fands">
          <Box
            sx={{
              width: "100%",
              mt: 2,
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            {isExcavationPermit && (
              <ExcavationPermitDetails
                work={permit.excavationView?.work || { ...common, ...work }}
                departments={permit.excavationView?.departments || departmentApprovals}
                warning={permit.excavationView?.warning}
              />
            )}
            {!isExcavationPermit && (<>
            {/* ── Row 1: Work Details + Hazards (existing for all permits) ── */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: 3,
              }}
            >
              <Box sx={{ flex: 1 }}>{renderWorkDetails()}</Box>
              <Box sx={{ flex: 1 }}>{renderHazards()}</Box>
            </Box>

            </>)}
            {isExcavationPermit && hazards.length > 0 && renderHazards()}

            {/* ── Checklist (existing for all permits) ── */}
            {checklist.length > 0 && renderChecklist()}

            {/* ── EXCAVATION-SPECIFIC SECTIONS ── */}
            {isExcavationPermit && (
              <>


                {signatures.length > 0 && renderSignatures()}
                {workflowLogs.length > 0 && renderWorkflowLogs()}
              </>
            )}
          </Box>
        </div>

        {/* FOOTER BUTTONS */}
        <div className="footer">
          <div className="button-group">
            <button
              className="data-form-cancel-button"
              onClick={handleCancelClick}
            >
              Cancel
            </button>

            {(common?.request_status === "O&M Verified" ||
              common?.request_status === "Fire&Safety Verified") ? (
              <>
                <button
                  style={{ marginLeft: "10px" }}
                  className="data-form-save-button approverd-button-permit approve_btn_clr"
                  type="button"
                  onClick={handleApproveConfirm}
                >
                  Approve
                </button>

                <button
                  className="data-form-reject-button"
                  type="button"
                  onClick={() => setShowRejectPopup(true)}
                >
                  Reject
                </button>
              </>
            ) : null}
          </div>
        </div>

        {/* SNACKBAR */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MuiAlert
            severity={severity}
            variant="filled"
            onClose={handleSnackbarClose}
          >
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>
      </div>

      {/* APPROVE CONFIRM POPUP */}
      {isApprovePopupOpen && (
        <div className="permit-approval-popup">
          <div className="permit-approval-popup-content">
            <div className="approval-popup-header">Confirm Approval</div>
            <p className="approval-popup-message">
              Are you sure you want to approve this permit?
            </p>
            <div className="approval-popup-buttons">
              <button className="approve-button approve_btn_clr" onClick={confirmApprove}>
                Yes, Approve
              </button>
              <button className="cancel-button" onClick={closeApprovePopup}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* REJECT CONFIRM POPUP */}
      {showRejectPopup && (
        <div className="confirm-delete-popup">
          <div className="confirm-delete-popup-content">
            <div className="confirm-model">
              <div className="confirm-model-content">
                <div className="confirm-model-content-body">
                  <p>Are you sure you want to reject this request?</p>
                </div>
                <div className="confirm-model-content-footer">
                  <button
                    className="reject-confirm-button"
                    onClick={handleRejectConfirm}
                  >
                    Yes, Reject
                  </button>
                  <button
                    className="reject-cancel-button"
                    onClick={() => setShowRejectPopup(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* REJECT REASON POPUP */}
      {isPopupOpen && (
        <div className="permit-popup-model">
          <div className="permit-popup-content">
            <div className="reminder-popup-model-header">
              <div className="reminder-popup-model-content-header-left-part">
                Reject Request Permit
              </div>

              <div className="popup-new-form">
                <form className="permit-popup-form-detail">
                  <div className="new-data-form">
                    <div className="form-group email-filed">
                      <label htmlFor="reason">
                        Reason <span className="text-danger">*</span>
                      </label>

                      <div className="input-group">
                        <textarea
                          id="reason"
                          name="reason"
                          placeholder="Enter reason for rejection"
                          value={reason}
                          onChange={handleReasonChange}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div className="footers">
                <div className="button-group-email">
                  <button
                    className="person-user-save-button"
                    onClick={handleSaveRejectClick}
                    disabled={isLoading}
                  >
                    {isLoading ? "Rejecting" : "Reject"}
                  </button>

                  <button
                    className="person-user-cancel-button"
                    onClick={closePopup}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default IssuerViewDetails;